import { Badge } from '@/components/ui/badge';
import { icpFitLabel, icpFitVariant } from '../constants';

/** A lead's ICP fit (ADR-108), optionally followed by the segment it matches. */
export function IcpFitBadge({ fit, segmentName }: { fit: string; segmentName?: string | null }) {
  return (
    <>
      <Badge variant={icpFitVariant(fit)}>{icpFitLabel(fit)}</Badge>
      {segmentName ? (
        <span className="text-muted-foreground ml-2 text-xs">{segmentName}</span>
      ) : null}
    </>
  );
}
